import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../component/login.css";

const Login = ({ setIsAuthenticated }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://seeree.in/api/loginUser", form);
      
      console.log("Login response:", response.data); // Debugging log

      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user)); // Store user data
        setIsAuthenticated(true); // Update authentication state
        console.log("Login successful! isAuthenticated set to true"); // Debugging log
        navigate("/landing"); // Redirect to landing page
      } else {
        setMessage("Invalid credentials");
      }
    } catch (error) {
      setMessage("Error logging in. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login Here</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="login-button">Login</button>
        </form>

        {message && <p className="error-message">{message}</p>}
      </div>
    </div>
  );
};

export default Login;
